module.exports = __webpack_public_path__ + "static/media/akrunow.f7aa2bd5.jpg";